import React, { Component, ReactNode } from "react";
import { GtmService } from "../GtmService";

type ErrorBoundaryState = {
  hasError: boolean;
};

type ErrorBoundaryProps = {
  message: string;
  children: ReactNode;
};

export class ErrorBoundary extends Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: any, errorInfo: any) {
    GtmService.genericError(error.message);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          className="error-boundary"
          dangerouslySetInnerHTML={{ __html: this.props.message }}
        />
      );
    }

    return this.props.children;
  }
}
